import script from "./SpdtDetail.vue?vue&type=script&setup=true&lang=js"
export * from "./SpdtDetail.vue?vue&type=script&setup=true&lang=js"

import "./SpdtDetail.vue?vue&type=style&index=0&id=c56fff48&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c56fff48"]])

export default __exports__